import toast from "react-hot-toast";

export const NotifyHelper = {
    Success: (msg: string) => toast.success(msg),
    Error: (msg: string) => toast.error(msg),
    Info: (msg: string) => toast(msg),
};
